export default "__VITE_ASSET__C1Jl3wbw__"